import anime from 'animejs';

export const indexBounceAnimation = (config: anime.AnimeParams) => {
  return anime({ duration: 1500, easing: 'easeOutElastic(1, 2)', delay: 500, ...config });
};
